import * as types from './types'
import { deleteCacheKeys as deleteCacheKeysRequest, getCacheKeys as getCacheKeysRequest } from '@cbgms/api/modules/support/requests'

export const getCacheKeys = (searchTerm: string) => ({
  type: [types.GET_CACHE_KEYS, types.GET_CACHE_KEYS_SUCCESS, types.GET_CACHE_KEYS_FAILED],
  payload: {
    api: 'support',
    request: getCacheKeysRequest(searchTerm)
  }
})

export const deleteCacheKeys = (searchTerm: string) => ({
  type: [types.DELETE_CACHE_KEYS, types.DELETE_CACHE_KEYS_SUCCESS, types.DELETE_CACHE_KEYS_FAILED],
  payload: {
    api: 'support',
    request: deleteCacheKeysRequest(searchTerm)
  }
})
